'use strict';

import constants from 'Constants.js';
import  _ from 'lodash';
import template from 'common-views/synchronize-modal.ejs';
import {Model, View} from 'backbone';
import eventBus from 'EventBus.js';
import $ from "jquery";
import util from 'util/Util.js';


class SynchronizeModalView extends View {
    initialize(opts) {
        this.options = opts || {};
        this.template = template;
        this.tagName = 'div';
        this.id = opts.el;
        this.gridEl = constants.PROP_MAIN_TABLE_MODAL;

        this.model.set({
            colModel: [
                {
                    name: 'accountId',
                    index: 'accountId',
                    editable: false,
                    hidden: true
                },
                {
                    name: 'type',
                    index: 'type',
                    editable: false,
                    width: 100
                },
                {
                    name: 'action',
                    index: 'action',
                    editable: false,
                    width: 100
                },
                {
                    name: 'name',
                    index: 'name',
                    editable: false,
                    width: 250
                },
                {
                    name: 'confirm',
                    width: 100,
                    align: "center",
                    editoptions: { value: "True:False" },
                    editrules: { required: true },
                    formatter: "checkbox",
                    formatoptions: { disabled: false },
                    editable: true
                }
            ],
            colNames: ['Id', 'Type', 'Action','Name','Confirm']
        });
        this.listenTo(this.model, 'change', this.render);
        this.onResize();

        return this;
    }

    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    onResize() {
        $(window).bind('resize', () => {
            this.resizeGrid();
        })
    }

    closeModal() {
        this.clearEventBus();
        $(constants.SELECT_FIELD_ID).remove();
    }

    confirmAll(ev){
        let accountTypes=this.model.get('accountTypes');
        let commitAccountTypes=this.model.get('commitAccountTypes');
        let filter=$("#accountFilter").val();
        let list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
        switch(filter){
            case 'all':
                for(let i=0;i < list.length;i++){
                    $(constants.PROP_MAIN_TABLE_MODAL).jqGrid("setCell", i, "confirm", true);
                }
                commitAccountTypes = _.cloneDeep(accountTypes);
                break;
            case 'user':
                list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
                this.confirmRowByType(list,'User');
                commitAccountTypes.Users = _.cloneDeep(accountTypes.Users);
                break;
            case 'userGroup':
                list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
                this.confirmRowByType(list,'User Group');
                commitAccountTypes.UserGroups = _.cloneDeep(accountTypes.UserGroups);
                break;
            case 'position':
                list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
                this.confirmRowByType(list,'Position');
                commitAccountTypes.Positions = _.cloneDeep(accountTypes.Positions);
                break;
            case 'new':
                list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
               this.confirmRowByAction(list,'New');
                if(commitAccountTypes.Users && commitAccountTypes.Users.New){commitAccountTypes.Users.New = _.cloneDeep(accountTypes.Users.New)}
                if(commitAccountTypes.UserGroups && commitAccountTypes.UserGroups.New){commitAccountTypes.UserGroups.New = _.cloneDeep(accountTypes.UserGroups.New)}
                if(commitAccountTypes.Positions && commitAccountTypes.Positions.New){commitAccountTypes.Positions.New = _.cloneDeep(accountTypes.Positions.New)}
                break;
            case 'change':
                list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
                this.confirmRowByAction(list,'Change');
                if(commitAccountTypes.Users && commitAccountTypes.Users.Change){commitAccountTypes.Users.Change = _.cloneDeep(accountTypes.Users.Change)}
                if(commitAccountTypes.UserGroups && commitAccountTypes.UserGroups.Change){commitAccountTypes.UserGroups.Change = _.cloneDeep(accountTypes.UserGroups.Change)}
                if(commitAccountTypes.Positions && commitAccountTypes.Positions.Change){commitAccountTypes.Positions.Change = _.cloneDeep(accountTypes.Positions.Change)}
                break;
            case 'remove':
                list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
                this.confirmRowByAction(list,'Remove');
                if(commitAccountTypes.Users && commitAccountTypes.Users.Remove){commitAccountTypes.Users.Remove = _.cloneDeep(accountTypes.Users.Remove)}
                if(commitAccountTypes.UserGroups && commitAccountTypes.UserGroups.Remove){commitAccountTypes.UserGroups.Remove = _.cloneDeep(accountTypes.UserGroups.Remove)}
                if(commitAccountTypes.Positions && commitAccountTypes.Positions.Remove){commitAccountTypes.Positions.Remove = _.cloneDeep(accountTypes.Positions.Remove)}
                break;
        }
        this.model.set('commitAccountTypes',commitAccountTypes,{silent:true});
    }

    confirmRowByType(list,type){
        for(let i=0;i < list.length;i++){
            if($(constants.PROP_MAIN_TABLE_MODAL).getRowData(list[i]).type === type){
                $(constants.PROP_MAIN_TABLE_MODAL).jqGrid("setCell", i, "confirm", true);
            }
        }
    }

    confirmRowByAction(list,action){
        for(let i=0;i < list.length;i++){
            if($(constants.PROP_MAIN_TABLE_MODAL).getRowData(list[i]).action === action){
                $(constants.PROP_MAIN_TABLE_MODAL).jqGrid("setCell", i, "confirm", true);
            }
        }
    }

    unconfirmAll(){
        let commitAccountTypes=this.model.get('commitAccountTypes');
        let filter=$("#accountFilter").val();
        let list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
        switch(filter){
            case 'all':
                for(let i=0;i < list.length;i++){
                    $(constants.PROP_MAIN_TABLE_MODAL).jqGrid("setCell", i, "confirm", false);
                }
                if(commitAccountTypes.Users){
                    commitAccountTypes = this.clearActionDataByType(commitAccountTypes,"Users");
                }
                if(commitAccountTypes.UserGroups){
                    commitAccountTypes = this.clearActionDataByType(commitAccountTypes,"UserGroups");
                }
                if(commitAccountTypes.Positions){
                    commitAccountTypes = this.clearActionDataByType(commitAccountTypes,"Positions");
                }

                break;
            case 'user':
                list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
                this.unConfirmRowByType(list,'User');
                if(commitAccountTypes.Users){
                    commitAccountTypes = this.clearActionDataByType(commitAccountTypes,"Users");
                }
                break;
            case 'userGroup':
                list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
                this.unConfirmRowByType(list,'User Group');
                if(commitAccountTypes.UserGroups){
                    commitAccountTypes = this.clearActionDataByType(commitAccountTypes,"UserGroups");
                }
                break;
            case 'position':
                list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
                this.unConfirmRowByType(list,'Position');
                if(commitAccountTypes.Positions){
                    commitAccountTypes = this.clearActionDataByType(commitAccountTypes,"Positions");
                }
                break;
            case 'new':
                list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
                this.unConfirmRowByAction(list,'New');
                commitAccountTypes=this.clearTypeByAction(commitAccountTypes,'New');
                break;
            case 'change':
                list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
                this.unConfirmRowByAction(list,'Change');
                commitAccountTypes=this.clearTypeByAction(commitAccountTypes,'Change');
                break;
            case 'remove':
                list = $(constants.PROP_MAIN_TABLE_MODAL).getDataIDs();
                this.unConfirmRowByAction(list,'Remove');
                commitAccountTypes=this.clearTypeByAction(commitAccountTypes,'Remove');
                break;
        }
        this.model.set('commitAccountTypes',commitAccountTypes,{silent:true});
    }

    unConfirmRowByType(list,type){
        for(let i=0;i < list.length;i++){
            if($(constants.PROP_MAIN_TABLE_MODAL).getRowData(list[i]).type === type){
                $(constants.PROP_MAIN_TABLE_MODAL).jqGrid("setCell", i, "confirm", false);
            }
        }
    }

    unConfirmRowByAction(list,action){
        for(let i=0;i < list.length;i++){
            if($(constants.PROP_MAIN_TABLE_MODAL).getRowData(list[i]).action === action){
                $(constants.PROP_MAIN_TABLE_MODAL).jqGrid("setCell", i, "confirm", false);
            }
        }
    }

    clearTypeByAction(commitAccountTypes,action){
        if(commitAccountTypes.Users && commitAccountTypes.Users[action]){
            commitAccountTypes.Users[action]=[];
        }
        if(commitAccountTypes.UserGroups && commitAccountTypes.UserGroups[action]){
            commitAccountTypes.UserGroups[action]=[];
        }
        if(commitAccountTypes.Positions && commitAccountTypes.Positions[action]){
            commitAccountTypes.Positions[action]=[];
        }

        return commitAccountTypes;
    }

    clearActionDataByType(commitAccountTypes,type){
        if(commitAccountTypes[type].New){
            commitAccountTypes[type].New =[];
        }
        if(commitAccountTypes[type].Remove){
            commitAccountTypes[type].Remove =[];
        }
        if(commitAccountTypes[type].Change){
            commitAccountTypes[type].Change =[];
        }
        return commitAccountTypes;
    }

    renderDialog(resolve,reject){
        this.$el.html(template(this.model.toJSON()));
        $('body').append(this.$el);

        // Show modal popup window
        this.el = $(constants.SELECT_FIELD_ID).dialog({
            dialogClass: "no-close",
            autoOpen: true,
            height: 700,
            width: 600,
            modal: true,
            resizable: true,
            buttons: [
                {
                    text: 'Commit',
                    'class': 'btn btn-default',
                    'disabled': false,
                    click: () => {
                        this.closeModal();
                        resolve(this.model.get('commitAccountTypes'));
                    }
                },
                {
                    text: 'Cancel',
                    'class': 'btn btn-default',
                    click: () => {
                        this.closeModal();
                        resolve('Cancel');
                    }
                }
            ],
            close: () => {
                this.unbindListEvent();
                this.closeModal();
            },
            open: () => {
                this.bindListEvent();
                $(constants.SELECT_FIELD_ID).css('overflow', 'hidden')
            }
        });

        $('div[role="dialog"]').draggable({containment: 'body', scroll: false});
        // Attaching current scope to the change event of the dialog.
        //$(constants.SELECT_FIELD_ID).on('change', $.proxy(this.selectItem, this));
    }

    fillNewRow(index, accountId, type, action,name,confirm) {
        $(this.gridEl).addRowData(index, {accountId, type, action,name,confirm});
    }

    setRow(rowId,e){
        let rowData = $(this.gridEl).jqGrid('getRowData', rowId);
        let accountTypes=this.model.get("accountTypes");
        let user,userGroup,position;
        if(rowData.type === 'User'){
            switch (rowData.action){
                case 'New':
                    user = _.find(accountTypes.Users.New,(currentUser)=>{
                        return currentUser['_guid'] === rowData.accountId;
                    });
                    if(user){
                        let logMessage=this.generateTypeLogMessage(user,'_guid');

                        $("textarea[name=logText]")
                            .val(`${logMessage}`)
                    }
                    break;

                case 'Change':
                    user = _.find(accountTypes.Users.Change,(currentUser)=>{
                        return currentUser['_id'] === rowData.accountId;
                    });
                    if(user){
                        let logMessage=this.generateTypeLogMessage(user,'_id');

                        $("textarea[name=logText]")
                            .val(`${logMessage}`)
                    }
                    break;

                case 'Remove':
                     user = _.find(accountTypes.Users.Remove,(user)=>{
                        return user['_id'] === rowData.accountId;
                    });
                    if(user) {
                        $("textarea[name=logText]")
                            .val(`Status: ${user['_Status']}`)
                    }
                    break;
                default: $("textarea[name=logText]").val('');
            }
        }
        else if(rowData.type === 'User Group'){
            switch (rowData.action){
                case 'New':
                    userGroup = _.find(accountTypes.UserGroups.New,(currentUser)=>{
                        return currentUser['_guid'] === rowData.accountId;
                    });
                    if(userGroup && userGroup.Member){
                        let logMessage= this.generateMemberLogMessage("Members:",userGroup.Member);

                        $("textarea[name=logText]")
                            .val(`${logMessage}`)
                    }
                    break;

                case 'Change':
                    userGroup = _.find(accountTypes.UserGroups.Change,(currentUser)=>{
                        return currentUser['_id'] === rowData.accountId;
                    });
                    if(userGroup){
                        let logMessage="";
                       if(userGroup.New) {
                           logMessage += 'New members:';
                           logMessage = this.generateMemberLogMessage(logMessage,userGroup.New.Member);
                           logMessage +='; ';
                       }
                        if(userGroup.Remove) {
                            logMessage += 'Remove members:';
                            logMessage = this.generateMemberLogMessage(logMessage,userGroup.Remove.Member);
                       }
                        $("textarea[name=logText]")
                            .val(`${logMessage}`);
                    }
                    break;
                default: $("textarea[name=logText]").val('');
            }
        }
        else if(rowData.type === 'Position'){
            switch (rowData.action){
                case 'New':
                    position = _.find(accountTypes.Positions.New,(currentUser)=>{
                        return currentUser['_guid'] === rowData.accountId;
                    });
                    if(position && position.Member){
                        let logMessage="Members:";
                        logMessage = this.generateMemberLogMessage(logMessage,position.Member);

                        $("textarea[name=logText]")
                            .val(`${logMessage}`)
                    }
                    break;

                case 'Change':
                    position = _.find(accountTypes.Positions.Change,(currentUser)=>{
                        return currentUser['_id'] === rowData.accountId;
                    });
                    if(position){
                        let logMessage="";
                        if(position.New) {
                            logMessage += 'New members:';
                            logMessage = this.generateMemberLogMessage(logMessage,position.New.Member);
                            logMessage +='; '
                        }
                        if(position.Remove) {
                            logMessage += 'Remove members:';
                            logMessage = this.generateMemberLogMessage(logMessage,position.Remove.Member);
                        }
                        $("textarea[name=logText]")
                            .val(`${logMessage}`);
                    }
                    break;
                default: $("textarea[name=logText]").val('');
            }
        }
            return true;
    }

    generateTypeLogMessage(item,id){
        let logMessage="";
        Object.entries(item).forEach(([attribute, value]) => {
            if(attribute !== id && attribute !== '_name'){
                let attributeFormatted = attribute.replace('_','');
                logMessage += `${attributeFormatted}:${value}; `;
            }
        });

        return logMessage;
    }

    generateMemberLogMessage(initialText,members){
        let logMessage=initialText;
        let membersArray=util.enforceArrayType(members);
        membersArray.forEach((member,index)=>{
            if(index === membersArray.length - 1){
                logMessage+=`${member['_name']}`
            }
            else{
                logMessage+=`${member['_name']},`
            }
        });
        return logMessage;
    }


    onSelectRow(rowId, status,e){}
    onCellSelect(rowid, iCol, cellcontent,e){
        let $self = $(this.gridEl),
            cm = $self.jqGrid("getGridParam", "colModel"),
            localData = $self.jqGrid("getLocalRow", rowid);
        if (cm[iCol].name === "confirm" && e.target.tagName.toUpperCase() === "INPUT") {
            // set local grid data
            localData.confirm = $(e.target).is(":checked");
            if(localData.confirm){
                switch (localData.type){
                    case 'User':this.processConfirmedItem(localData,'Users');break;
                    case 'User Group':this.processConfirmedItem(localData,'UserGroups');break;
                    case 'Position':this.processConfirmedItem(localData,'Positions');break;
                }
            }
            else{
                switch (localData.type){
                    case 'User':this.processUnConfirmedItem(localData,'Users');break;
                    case 'User Group':this.processUnConfirmedItem(localData,'UserGroups');break;
                    case 'Position':this.processUnConfirmedItem(localData,'Positions');break;
                }
            }
        }
    }

    processConfirmedItem(localData,type){
        let itemToConfirm,
            accountTypes = this.model.get('accountTypes'),
            commitAccountTypes = this.model.get('commitAccountTypes');
        switch (localData.action){
            case 'Remove':
                itemToConfirm=_.find(accountTypes[type].Remove,(item)=>{
                    return item['_id'] === localData.accountId;
                });
                commitAccountTypes[type].Remove.push(itemToConfirm);
                break;
            case 'Change':
                itemToConfirm=_.find(accountTypes[type].Change,(item)=>{
                    return item['_id'] === localData.accountId;
                });
                commitAccountTypes[type].Change.push(itemToConfirm);
                break;
            case 'New':
                itemToConfirm=_.find(accountTypes[type].New,(item)=>{
                    return item['_guid'] === localData.accountId;
                });
                commitAccountTypes[type].New.push(itemToConfirm);
                break;
        }
        this.model.set('commitAccountTypes',commitAccountTypes,{silent:true});
    }

    processUnConfirmedItem(localData,type){
        let commitAccountTypes = this.model.get('commitAccountTypes');
        switch (localData.action){
            case 'Remove':
                _.remove(commitAccountTypes[type].Remove,(user)=>{
                    return user['_id'] === localData.accountId;
                });
                break;
            case 'Change':
                _.remove(commitAccountTypes[type].Change,(user)=>{
                    return user['_id'] === localData.accountId;
                });
                break;
            case 'New':
                _.remove(commitAccountTypes[type].New,(user)=>{
                    return user['_guid'] === localData.accountId;
                });
                break;
        }
        this.model.set('commitAccountTypes',commitAccountTypes,{silent:true});
    }

    renderGrid() {
        util.deleteGridRows(this.gridEl);
        let gridObject = util.getGridObject(this,{height:500,maxHeight:600,scrollOffset:0,cellEdit:false});
        let accountTypes = this.model.get('accountTypes');
        $(this.gridEl).jqGrid(gridObject);
        $(this.gridEl).jqGrid("setLabel","type","",{"text-align":"left"});
        $(this.gridEl).jqGrid("setLabel","action","",{"text-align":"left"});
        $(this.gridEl).jqGrid("setLabel","name","",{"text-align":"left"});
        $(this.gridEl).jqGrid("setLabel","confirm","",{"text-align":"left"});



        if(_.some(accountTypes)){
            this.fillTableWithAccountData(accountTypes);
        }

        else{
            // Fill default empty rows
            for (let i = 0; i < 12; i++) {
                this.fillNewRow(i, '', '', '','','');
            }
        }


        this.resizeGrid();
        this.delegateEvents();
        this.$el.css('cursor', 'default');
    }

    fillTableWithAccountData(accountTypes){
        let index=0;
        if (accountTypes.Users) {
            if(accountTypes.Users.New){
                _.forEach(accountTypes.Users.New,(user)=>{
                    this.fillNewRow(index,user['_guid'],"User",'New',user['_firstName'] + ' ' + user['_lastName'],true);
                    index++;
                })
            }
            if(accountTypes.Users.Remove){
                _.forEach(accountTypes.Users.Remove,(user)=>{
                    this.fillNewRow(index,user['_id'],"User",'Remove',user['_name'],true);
                    index++;
                })
            }
            if(accountTypes.Users.Change){
                _.forEach(accountTypes.Users.Change,(user)=>{
                    this.fillNewRow(index,user['_id'],"User",'Change',user['_name'],true);
                    index++;
                })
            }
        }
        if(accountTypes.UserGroups){
            if(accountTypes.UserGroups.New){
                _.forEach(accountTypes.UserGroups.New,(userGroup)=>{
                    this.fillNewRow(index,userGroup['_guid'],"User Group",'New',userGroup['_name'],true);
                    index++;
                })
            }
            if(accountTypes.UserGroups.Remove){
                _.forEach(accountTypes.UserGroups.Remove,(userGroup)=>{
                    this.fillNewRow(index,userGroup['_id'],"User Group",'Remove',userGroup['_name'],true);
                    index++;
                })
            }
            if(accountTypes.UserGroups.Change){
                _.forEach(accountTypes.UserGroups.Change,(userGroup)=>{
                    this.fillNewRow(index,userGroup['_id'],"User Group",'Change',userGroup['_name'],true);
                    index++;
                })
            }
        }
        if(accountTypes.Positions){
            if(accountTypes.Positions.New){
                _.forEach(accountTypes.Positions.New,(position)=>{
                    this.fillNewRow(index,position['_guid'],"Position",'New',position['_name'],true);
                    index++;
                })
            }
            if(accountTypes.Positions.Remove){
                _.forEach(accountTypes.Positions.Remove,(position)=>{
                    this.fillNewRow(index,position['_id'],"Position",'Remove',position['_name'],true);
                    index++;
                })
            }
            if(accountTypes.Positions.Change){
                _.forEach(accountTypes.Positions.Change,(position)=>{
                    this.fillNewRow(index,position['_id'],"Position",'Change',position['_name'],true);
                    index++;
                })
            }
        }
    }


    bindListEvent(){
        $('input[name="confirmAll"]').click((e)=>{
            this.confirmAll(e);
        });
        $('input[name="unconfirmAll"]').click((e)=>{
            this.unconfirmAll(e);
        });
    }

    render() {
        return new Promise((resolve, reject) => {
            this.$el.html(template(this.model.toJSON()));
            this.renderDialog(resolve, reject);
            this.renderGrid();

            // Centering buttons
            $(".ui-dialog .ui-dialog-buttonpane").css( "text-align","center");
            $(".ui-dialog .ui-dialog-buttonpane .ui-dialog-buttonset").css("float", "none");

            this.delegateEvents();
            return this;
        });
    }

    clearEventBus() {
        eventBus.off(constants.FIELD_SELECTED);
        eventBus.off(constants.FIELD_SELECTED_CLEAR);
    }
}

export default SynchronizeModalView;
